/**
 * @param {OnlineTask} task
 * @param {RedemptionService} redemptionService
 *
 * @returns {Promise}
 */
const redemptionTaskHandler = (task, redemptionService) => {
    task.data.onlineTaskTrigger = task.onlineTaskTrigger;
    // Wrapping in a real promise because remoteRedemption uses Angular's $q.
    return new Promise((resolve, reject) => {
        redemptionService
            .doRemoteRedemption(task.data)
            .then(resolve)
            .catch(reject);
    });
};

module.exports = redemptionTaskHandler;
